import {inject} from 'aurelia-framework';
import Backend from "../backend";
import {activationStrategy, Redirect, RedirectToRoute, Router} from 'aurelia-router';
import {redirectToActiveSeoKey} from "../util/redirect-to-active-seo-key";
import {MetaTags} from "../util/meta-tags";
import {UserInfoProvider} from "../util/user-info-provider";

@inject(Backend, Router, UserInfoProvider)
export class ProductScreen {
  backend;
  router;
  userInfoProvider;

  visibleBundleConfiguration;

  constructor(backend, router, userInfoProvider) {
    this.backend = backend;
    this.router = router;
    this.userInfoProvider = userInfoProvider
  }

  canActivate(params, routeConfig) {
    return this.backend.ProductDetailsQueryHandler_handle({productIdOrSeoKey: params.productIdOrSeoKey, maxAdditionalWeekCount: 2})
        .then(result => {
          if (result === null) {
             throw new Error('Product not found: ' + params.productIdOrSeoKey);
          }

          this.product = result;

          // Enforce non-crates only because the url is "produkt" and there is a separate url for "matkasse"
          if (this.product.isCrate) {
            throw new Error('This screen can show only non-crate products. productIdOrSeoKey: ' + params.productIdOrSeoKey);
          }

          // SEO: Title
          routeConfig.navModel.setTitle(this.product.name + ' | ' + routeConfig.title);

          // SEO: Meta tags
          MetaTags.setMetaTags_rememberToCallCleanOnUnbind(this.product.descriptionMetaTag);

          // SEO: structured data
          let structuredData = ProductScreen.toStructuredProductData(this.product);
          this.productStructuredDataJson = JSON.stringify(structuredData);

          // SEO: handle seokey
          return redirectToActiveSeoKey(params, routeConfig, 'productIdOrSeoKey', this.product.seoKey);
        });
  }

  activate() {
    return Promise.all([

    ]);
  }

  unbind() {
    MetaTags.cleanMetaTags();
  }

  buy() {
    if (this.userInfoProvider.getInfo().hasSubscription) {
      this.router.navigateToRoute('instant-checkout-route', {checkoutProductId: this.product.productId});
    } else {
      this.crateChoiceModalComponentRef.show([{productId: this.product.productId, quantity: 1}]);
    }
  }

  // When we retry and it fails again we need to reload this screen with new data, not just keep the view model we have.
  determineActivationStrategy() {
    return activationStrategy.replace;
  }

  static toStructuredProductData(product) {
    const price = ProductScreen.formatForStructuredData(product.priceIncVat);
    const lowPrice = ProductScreen.formatForStructuredData(product.minPriceIncVat);
    return {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": product.nameAndUnit,
      "image": product.imageUrl,
      "description": product.description,
      "brand": {
        "@type": "Brand",
        "name": "Rågo"
      },
      "offers": {
        "@type": price
          ? "Offer"
          : lowPrice
            ? "AggregateOffer"
            : null,
        "price": price,
        "lowPrice": lowPrice,
        "priceCurrency": "NOK",
        "availability": "https://schema.org/InStock"
      }
    };
  }

  static formatForStructuredData(priceIncVat) {
    return                 priceIncVat
      && !isNaN(parseFloat(priceIncVat))
      &&  isFinite(        priceIncVat)
        ? priceIncVat.toFixed(2)
        : undefined;
  }
}
